// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Lesbarkeit auf dem Handy (meistgenutzte Ansicht, auch ältere Nutzer):
 * Kleinschrift nicht unter ~13 px, Fließtext 17 px, Tippflächen mindestens 44 px.
 * Jeder Selektor beginnt mit :root, damit er die Komponenten-Styles sicher überschreibt.
 */
@media (max-width: 680px) {
  /* ---------- Kleine Beschriftungen ---------- */
  :root .ui-eyebrow,
  :root .note-label,
  :root .tag,
  :root .feature-req,
  :root .sg-avail-chip,
  :root .provider-fact,
  :root .price-tax,
  :root .home-count,
  :root .footer-bottom,
  :root .current-language-code,
  :root .newsletter-frequency-hint {
    font-size: 0.8rem;
    letter-spacing: 0.04em;
  }

  :root .breadcrumbs {
    font-size: 0.82rem;
  }

  :root .card-spec {
    font-size: 0.82rem;
  }

  :root .product-specs dt {
    font-size: 0.8rem;
  }

  :root .segmented button,
  :root .menu-path,
  :root .breadcrumbs li {
    font-size: 0.85rem;
  }

  :root .logo {
    min-height: 44px;
  }

  :root .product-specs dd {
    font-size: 1.15rem;
  }

  :root .feature-more,
  :root .product-datafields-link,
  :root .help-faq-link {
    font-size: 0.85rem;
  }

  :root .btn,
  :root .newsletter-btn {
    min-height: 48px;
    font-size: 0.9rem;
  }

  :root label,
  :root .form-field label,
  :root .form-hint {
    font-size: 0.95rem;
  }

  /* Text in Feldern, Namen von Einstellungen und Uhr-Anzeigen */
  :root .watch-text,
  :root .setting-name,
  :root .ui-label {
    font-size: 0.95em;
  }

  :root .theme-string {
    font-size: 0.85rem;
  }

  /* Datenfeld-Namen und Legenden */
  :root .sg-rows dt,
  :root .legend-list dt,
  :root .def-list dt {
    font-size: 0.95rem;
  }

  :root .sg-rows dd p,
  :root .legend-list dd,
  :root .def-list dd {
    font-size: 1rem;
  }

  :root .symptom-what,
  :root .guide-tile-desc,
  :root .figcaption,
  :root .guide-figure figcaption {
    font-size: 0.95rem;
  }

  :root .feature-body p,
  :root .product-features li {
    font-size: 1rem;
  }

  /* ---------- Tippflächen ---------- */
  :root .icon-btn {
    width: 44px;
    height: 44px;
    min-height: 44px;
  }

  :root .icon-btn.current-language {
    width: auto;
  }

  :root .faq-filter-btn {
    min-height: 44px;
    padding: 0.5rem 0.85rem;
    font-size: 0.82rem;
  }

  :root .guide-toc-inline a {
    display: inline-flex;
    align-items: center;
    min-height: 44px;
    padding: 0.4rem 0.75rem;
    font-size: 0.95rem;
  }

  :root .product-datafields-link,
  :root .feature-more {
    min-height: 44px;
  }

  :root .footer-social,
  :root .footer-logo,
  :root .footer a {
    display: inline-flex;
    align-items: center;
    min-height: 44px;
  }

  :root .wfid-where summary {
    padding: 0.6rem 0;
  }

  /* ---------- Icons ---------- */
  :root .section-tabs-prominent .section-tab .guide-icon {
    width: 22px;
    height: 22px;
  }

  :root .section-tabs-prominent .section-tab {
    font-size: 0.95rem;
  }
}

/* Kaufen auf dem Handy: Eingabefeld ganz lesbar, Schritte-Skala schmaler, Knopf über volle Breite */
@media (max-width: 680px) {
  :root .wfid-card .wfid-input {
    font-size: 1.2rem;
    letter-spacing: 0.06em;
  }

  :root .wfid-card .wfid-input::placeholder {
    letter-spacing: 0;
    font-size: 1rem;
  }

  :root .buy-steps > li {
    grid-template-columns: 2rem minmax(0, 1fr);
    gap: 0.6rem;
  }

  :root .wfid-card,
  :root .checkout-card {
    padding: 0.9rem 0.85rem;
  }

  :root .checkout-card .buy-btn {
    width: 100%;
  }

  :root .checkout-card .buy-row {
    flex-direction: column;
    align-items: stretch;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/mobile-readability.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,gDAAgD;EAChD;;;;;;;;;;;IAWE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA,8DAA8D;EAC9D;;;IAGE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,iCAAiC;EACjC;;;IAGE,kBAAkB;EACpB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;;;;IAIE,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;;IAGE,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,gCAAgC;EAChC;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,oGAAoG;AACpG;EACE;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,0CAA0C;IAC1C,WAAW;EACb;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF","sourcesContent":["/*\n * Lesbarkeit auf dem Handy (meistgenutzte Ansicht, auch ältere Nutzer):\n * Kleinschrift nicht unter ~13 px, Fließtext 17 px, Tippflächen mindestens 44 px.\n * Jeder Selektor beginnt mit :root, damit er die Komponenten-Styles sicher überschreibt.\n */\n@media (max-width: 680px) {\n  /* ---------- Kleine Beschriftungen ---------- */\n  :root .ui-eyebrow,\n  :root .note-label,\n  :root .tag,\n  :root .feature-req,\n  :root .sg-avail-chip,\n  :root .provider-fact,\n  :root .price-tax,\n  :root .home-count,\n  :root .footer-bottom,\n  :root .current-language-code,\n  :root .newsletter-frequency-hint {\n    font-size: 0.8rem;\n    letter-spacing: 0.04em;\n  }\n\n  :root .breadcrumbs {\n    font-size: 0.82rem;\n  }\n\n  :root .card-spec {\n    font-size: 0.82rem;\n  }\n\n  :root .product-specs dt {\n    font-size: 0.8rem;\n  }\n\n  :root .segmented button,\n  :root .menu-path,\n  :root .breadcrumbs li {\n    font-size: 0.85rem;\n  }\n\n  :root .logo {\n    min-height: 44px;\n  }\n\n  :root .product-specs dd {\n    font-size: 1.15rem;\n  }\n\n  :root .feature-more,\n  :root .product-datafields-link,\n  :root .help-faq-link {\n    font-size: 0.85rem;\n  }\n\n  :root .btn,\n  :root .newsletter-btn {\n    min-height: 48px;\n    font-size: 0.9rem;\n  }\n\n  :root label,\n  :root .form-field label,\n  :root .form-hint {\n    font-size: 0.95rem;\n  }\n\n  /* Text in Feldern, Namen von Einstellungen und Uhr-Anzeigen */\n  :root .watch-text,\n  :root .setting-name,\n  :root .ui-label {\n    font-size: 0.95em;\n  }\n\n  :root .theme-string {\n    font-size: 0.85rem;\n  }\n\n  /* Datenfeld-Namen und Legenden */\n  :root .sg-rows dt,\n  :root .legend-list dt,\n  :root .def-list dt {\n    font-size: 0.95rem;\n  }\n\n  :root .sg-rows dd p,\n  :root .legend-list dd,\n  :root .def-list dd {\n    font-size: 1rem;\n  }\n\n  :root .symptom-what,\n  :root .guide-tile-desc,\n  :root .figcaption,\n  :root .guide-figure figcaption {\n    font-size: 0.95rem;\n  }\n\n  :root .feature-body p,\n  :root .product-features li {\n    font-size: 1rem;\n  }\n\n  /* ---------- Tippflächen ---------- */\n  :root .icon-btn {\n    width: 44px;\n    height: 44px;\n    min-height: 44px;\n  }\n\n  :root .icon-btn.current-language {\n    width: auto;\n  }\n\n  :root .faq-filter-btn {\n    min-height: 44px;\n    padding: 0.5rem 0.85rem;\n    font-size: 0.82rem;\n  }\n\n  :root .guide-toc-inline a {\n    display: inline-flex;\n    align-items: center;\n    min-height: 44px;\n    padding: 0.4rem 0.75rem;\n    font-size: 0.95rem;\n  }\n\n  :root .product-datafields-link,\n  :root .feature-more {\n    min-height: 44px;\n  }\n\n  :root .footer-social,\n  :root .footer-logo,\n  :root .footer a {\n    display: inline-flex;\n    align-items: center;\n    min-height: 44px;\n  }\n\n  :root .wfid-where summary {\n    padding: 0.6rem 0;\n  }\n\n  /* ---------- Icons ---------- */\n  :root .section-tabs-prominent .section-tab .guide-icon {\n    width: 22px;\n    height: 22px;\n  }\n\n  :root .section-tabs-prominent .section-tab {\n    font-size: 0.95rem;\n  }\n}\n\n/* Kaufen auf dem Handy: Eingabefeld ganz lesbar, Schritte-Skala schmaler, Knopf über volle Breite */\n@media (max-width: 680px) {\n  :root .wfid-card .wfid-input {\n    font-size: 1.2rem;\n    letter-spacing: 0.06em;\n  }\n\n  :root .wfid-card .wfid-input::placeholder {\n    letter-spacing: 0;\n    font-size: 1rem;\n  }\n\n  :root .buy-steps > li {\n    grid-template-columns: 2rem minmax(0, 1fr);\n    gap: 0.6rem;\n  }\n\n  :root .wfid-card,\n  :root .checkout-card {\n    padding: 0.9rem 0.85rem;\n  }\n\n  :root .checkout-card .buy-btn {\n    width: 100%;\n  }\n\n  :root .checkout-card .buy-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
